import EDC from '../../../shared/globals';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.MatchingWords.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);
  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.MatchingWords.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.blimps = [];
  this.highlighted = [];
  this.direction = -1;
};

EDC.Games.MatchingWords.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.MatchingWords.Scenes.Main.prototype.constructor = EDC.Games.MatchingWords.Scenes.Main;

const IRW = EDC.Games.MatchingWords.Scenes.Main.prototype;

IRW.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

IRW.loadIteration = function () {
  this.createBlimps();
};

IRW.createTemplateUI = function () {
  this.add.sprite(950, 120, 'title');
  this.add.sprite(950, 1000, 'instructions');
};

IRW.createBlimps = function () {
  // eslint-disable-next-line max-len
  for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].words.length; i++) {
    const position = this.getBlimpPosition(this.difficulty, i);
    const font = {
      align: 'center',
      font: '76px Arial',
      fill: 'black',
      stroke: 'black',
      strokeThickness: 5,
      padding: {
        left: 0,
        right: 0,
        top: position.wordPaddingTop,
        bottom: 30,
      },
    };
    const blimpcont = this.add.container(position.blimpContainerX, position.blimpContainerY);
    const blimp = this.add.image(0, 0, `blimp-${this.gameConfig.blimpsCount[i]}`);
    const text = this.add
      .text(0, 0, this.gameConfig.sets[this.difficulty].iterations[this.iteration].words[i], font)
      .setOrigin(0.5);
    blimp.setScale(position.scale);
    blimpcont.add(blimp);
    blimpcont.add(text);
    blimpcont.wordText = this.gameConfig.sets[this.difficulty].iterations[this.iteration].words[i];
    blimpcont.setSize(position.blimpContainerWidth, position.blimpContainerHeight);
    blimpcont.setInteractive();
    this.cursorManager.setDefaultDraggableEvents(blimpcont);
    blimpcont.on('pointerup', this.checkClick.bind(this, blimpcont), this);
    this.blimps.push(blimpcont);
  }
  this.startCollision();
};

IRW.getBlimpPosition = function (difficulty, i) {
  const blimpPositions = {
    1: {
      coords: () => ({
        ...blimpPositions[1][i],
        scale: 1,
        blimpContainerWidth: 320,
        blimpContainerHeight: 390,
      }),
      0: {
        blimpContainerX: 510,
        blimpContainerY: 640,
        wordPaddingTop: 215,
      },
      1: {
        blimpContainerX: 930,
        blimpContainerY: 560,
        wordPaddingTop: 50,
      },
      2: {
        blimpContainerX: 1400,
        blimpContainerY: 640,
        wordPaddingTop: 25,
      },
    },
    2: {
      coords: () => ({
        ...blimpPositions[2][i],
        scale: 0.9,
        blimpContainerWidth: 295,
        blimpContainerHeight: 390,
      }),
      0: {
        blimpContainerX: 350,
        blimpContainerY: 640,
        wordPaddingTop: 195,
      },
      1: {
        blimpContainerX: 770,
        blimpContainerY: 460,
        wordPaddingTop: 45,
      },
      2: {
        blimpContainerX: 1200,
        blimpContainerY: 640,
        wordPaddingTop: 25,
      },
      3: {
        blimpContainerX: 1620,
        blimpContainerY: 600,
        wordPaddingTop: 25,
      },
    },
    3: {
      coords: () => ({
        ...blimpPositions[3][i],
        scale: 0.8,
        blimpContainerWidth: 265,
        blimpContainerHeight: 390,
      }),
      0: {
        blimpContainerX: 250,
        blimpContainerY: 640,
        wordPaddingTop: 170,
      },
      1: {
        blimpContainerX: 650,
        blimpContainerY: 540,
        wordPaddingTop: 50,
      },
      2: {
        blimpContainerX: 1000,
        blimpContainerY: 640,
        wordPaddingTop: 25,
      },
      3: {
        blimpContainerX: 1300,
        blimpContainerY: 550,
        wordPaddingTop: 30,
      },
      4: {
        blimpContainerX: 1700,
        blimpContainerY: 640,
        wordPaddingTop: 170,
      },
    },
  };
  return blimpPositions[difficulty].coords(i);
};

IRW.startCollision = function () {
  for (let i = 0; i < this.blimps.length; i++) {
    this.direction *= -1;
    const randomDistance = 20 + Math.round(Math.random() * 60);
    const randomTime = 1000 + Math.round(Math.random() * 400);
    // const randomDelay = Math.round(Math.random() * 800);
    this.physics.world.enable(this.blimps[i], 0);
    this.blimps[i].body
      .setVelocity(30 * this.direction + i * 5, 0)
      .setBounce(1)
      .setCollideWorldBounds(true);
    this.physics.add.collider(this.blimps[i], this.blimps[i + 1]);
    this.tweens.add({
      targets: this.blimps[i],
      y: this.blimps[i].y - randomDistance,
      duration: randomTime,
      ease: 'Sine.easeInOut',
      repeat: -1,
      yoyo: true,
    });
  }
};

IRW.checkClick = function (blimpcont) {
  if (this.highlighted.length === 0) {
    blimpcont.first.setTint(0x0ffff0);
    blimpcont.selected = true;
    this.highlighted.push(blimpcont);
  } else if (this.highlighted.length === 1) {
    if (blimpcont.selected) {
      blimpcont.first.clearTint();
      blimpcont.selected = false;
      this.highlighted = [];
    } else {
      this.highlighted.push(blimpcont);
      this.checkAnswer(blimpcont);
    }
  }
};

IRW.checkAnswer = function () {
  const correct = this.gameConfig.sets[this.difficulty].iterations[this.iteration].correctAnswer;
  const correctAnswers = this.highlighted.filter(x => correct.includes(x.wordText));
  if (Array.from(new Set(correctAnswers)).length === 2) {
    this.highlighted.map(x => x.first.clearTint());
    this.highlighted = [];
    this.playCorrect();
    this.time.delayedCall(2000, this.nextIteration, [], this);
  } else {
    this.changeColor();
    this.playWrong();
    this.time.delayedCall(2000, this.flash, [], this);
  }
};

IRW.nextIteration = function () {
  this.blimps.map(x => x.destroy());
  this.blimps = [];
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

IRW.changeColor = function () {
  this.highlighted.map(x => x.first.setTint(0xff0000));
};

IRW.flash = function () {
  this.cameras.main.flash();
  this.highlighted.map((x) => {
    x.first.clearTint();
    x.setInteractive();
    this.cursorManager.setDefaultDraggableEvents(x);
    return true;
  });
  this.highlighted = [];
};

export default EDC.Games.MatchingWords.Scenes.Main;
